import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import studentlogin from "../../assets/studentlogin.png";

import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

import {
  FaEye,
  FaEyeSlash,
  FaEnvelope,
  FaLock,
  FaShieldAlt,
  FaGraduationCap,
  FaUsers,
  FaStar,
  FaBookOpen,
  FaSyncAlt,
  FaSignInAlt,
} from "react-icons/fa";

import "../../Styles/StudentLogin.css";

import Member from "../Membership/Member";
import ApiService from "../../nhrc_apis/ApiService";

const { AuthAPI, PasswordAPI } = ApiService;

function StudentLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);

  const [captchaId, setCaptchaId] = useState("");
  const [captchaQuestion, setCaptchaQuestion] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");

  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [captchaLoading, setCaptchaLoading] = useState(false);

  /* =========================================================
     ✅ CORRECTED FORGOT PASSWORD STATES — same 2-step flow as
     the admin/HR logins; no reset token, OTP submitted
     directly to reset-password.
  ========================================================= */

  const [showForgot, setShowForgot] = useState(false);

  const [step, setStep] = useState(1);

  const [forgotEmail, setForgotEmail] = useState("");
  const [sendingForgotOtp, setSendingForgotOtp] = useState(false);

  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resettingPassword, setResettingPassword] = useState(false);

  const [showRegister, setShowRegister] = useState(false);

  useEffect(() => {
    loadCaptcha();
  }, []);

  const loadCaptcha = async () => {
    try {
      setCaptchaLoading(true);
      setCaptchaVerified(false);
      setCaptchaAnswer("");

      const res = await AuthAPI.getCaptcha();

      console.log("CAPTCHA RESPONSE :", res?.data);

      setCaptchaId(res?.data?.captcha_id || "");

      setCaptchaQuestion(res?.data?.question || "");
    } catch (err) {
      console.log("CAPTCHA ERROR :", err);

      toast.error(
        err?.response?.data?.detail ||
          "Failed to load captcha"
      );
    } finally {
      setCaptchaLoading(false);
    }
  };

  const handleVerifyCaptcha = async () => {
    if (!captchaAnswer.trim()) {
      toast.error("Please enter captcha answer!");
      return;
    }

    try {
      const res = await AuthAPI.verifyCaptcha({
        captcha_id: captchaId,
        answer: captchaAnswer.trim(),
      });

      console.log(
        "VERIFY CAPTCHA RESPONSE :",
        res?.data
      );

      setCaptchaVerified(true);

      toast.success("Captcha verified successfully!");
    } catch (err) {
      console.log("VERIFY CAPTCHA ERROR :", err);

      setCaptchaVerified(false);

      toast.error(
        err?.response?.data?.detail ||
          err?.response?.data?.message ||
          "Captcha verification failed"
      );

      loadCaptcha();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Please enter email");
      return;
    }

    if (!pass.trim()) {
      toast.error("Please enter password");
      return;
    }

    if (!captchaVerified) {
      toast.error("Please verify captcha first!");
      return;
    }

    if (!captchaId || !captchaAnswer.trim()) {
      toast.error("Captcha session expired. Please verify again.");
      setCaptchaVerified(false);
      loadCaptcha();
      return;
    }

    try {
      setLoading(true);

      localStorage.removeItem("adminToken");
      localStorage.removeItem("hrToken");
      localStorage.removeItem("employeeToken");
      localStorage.removeItem("studentToken");
      localStorage.removeItem("token");

      localStorage.removeItem("studentMember");
      localStorage.removeItem("studentLoggedInUser");

      const loginPayload = {
        email: email.trim().toLowerCase(),
        password: pass.trim(),
        captcha_id: captchaId,
        captcha: captchaAnswer.trim(),
      };

      console.log(
        "FINAL LOGIN PAYLOAD :",
        loginPayload
      );

      const res = await AuthAPI.login(loginPayload);

      console.log(
        "LOGIN RESPONSE :",
        res?.data
      );

      const token =
        res?.data?.token ||
        res?.data?.access_token ||
        "";

      const member =
        res?.data?.member ||
        res?.data?.user ||
        {};

      console.log(
        "MEMBER DATA :",
        member
      );

      if (!token) {
        toast.error("Token not received");
        return;
      }

      if (
        !member ||
        Object.keys(member).length === 0
      ) {
        toast.error("Member data missing");
        return;
      }

      const memberStatus =
        member?.status
          ?.toLowerCase()
          ?.trim();

      if (memberStatus !== "approved") {
        toast.error(
          "Your account is not approved yet!"
        );

        return;
      }

      const candidateType =
        member?.candidate_type
          ?.toLowerCase()
          ?.trim();

      const role =
        member?.role
          ?.toUpperCase()
          ?.trim();

      if (
        candidateType !== "student" &&
        role !== "STUDENT"
      ) {
        toast.error(
          "This login is only for students!"
        );

        return;
      }

      localStorage.setItem(
        "studentToken",
        token
      );

      localStorage.setItem(
        "token",
        token
      );

      localStorage.setItem(
        "studentMember",
        JSON.stringify(member)
      );

      const userData = {
        id: member?.id || "",

        name:
          member?.full_name ||
          member?.name ||
          "",

        email:
          member?.email || "",

        membership_id:
          member?.membership_id || "",

        role:
          member?.role || "STUDENT",

        candidate_type:
          member?.candidate_type ||
          "student",

        status:
          member?.status || "",

        approved_at:
          member?.approved_at || "",

        profile_pic:
          member?.profile_pic || "",
      };

      localStorage.setItem(
        "studentLoggedInUser",
        JSON.stringify(userData)
      );

      console.log(
        "STORED USER :",
        userData
      );

      toast.success(
        "Login successful!"
      );

      setTimeout(() => {
        navigate("/student");
      }, 1000);
    } catch (err) {
      console.log(
        "LOGIN ERROR :",
        err
      );

      console.log(
        "ERROR RESPONSE :",
        err?.response?.data
      );

      console.log(
        "ERROR STATUS :",
        err?.response?.status
      );

      if (err?.response?.status === 401) {
        toast.error(
          err?.response?.data?.detail ||
            "Invalid email or password"
        );
      } else if (
        err?.response?.status === 403
      ) {
        toast.error(
          err?.response?.data?.detail ||
            "Access denied"
        );
      } else if (
        err?.response?.status === 422
      ) {
        const detail = err?.response?.data?.detail;

        const detailMsg = Array.isArray(detail)
          ? (detail[0]?.msg || "Validation Error")
          : (detail || "Invalid request format");

        toast.error(detailMsg);
      } else {
        toast.error(
          err?.response?.data?.detail ||
            err?.response?.data?.message ||
            "Login failed!"
        );
      }

      setCaptchaVerified(false);

      loadCaptcha();
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     ✅ FORGOT PASSWORD — STEP 1: SEND OTP
     POST /password/forgot-password?email=...
  ========================================================= */

  const verifyEmail = async () => {
    if (!forgotEmail.trim()) {
      toast.error("Please enter email");
      return;
    }

    try {
      setSendingForgotOtp(true);

      await PasswordAPI.forgotPassword(
        forgotEmail.trim().toLowerCase()
      );

      toast.success("OTP sent to your email");

      setStep(2);
    } catch (err) {
      console.log("FORGOT PASSWORD ERROR :", err);

      toast.error(
        err?.response?.data?.detail ||
          "Failed to send OTP. Please check the email and try again."
      );
    } finally {
      setSendingForgotOtp(false);
    }
  };

  /* =========================================================
     ✅ FORGOT PASSWORD — STEP 2: RESET WITH OTP
     POST /password/reset-password
       { email, otp, new_password, confirm_password }
  ========================================================= */

  const setPasswordHandler = async () => {
    if (!otp.trim()) {
      toast.error("Please enter OTP");
      return;
    }

    if (newPassword.length < 6) {
      toast.error(
        "Password must be at least 6 characters"
      );

      return;
    }

    if (
      newPassword !== confirmPassword
    ) {
      toast.error(
        "Passwords do not match"
      );

      return;
    }

    try {
      setResettingPassword(true);

      await PasswordAPI.resetPassword({
        email: forgotEmail.trim().toLowerCase(),
        otp: otp.trim(),
        new_password: newPassword.trim(),
        confirm_password: confirmPassword.trim(),
      });

      toast.success(
        "Password changed successfully!"
      );

      setShowForgot(false);
      setStep(1);

      setForgotEmail("");
      setOtp("");

      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      console.log("RESET PASSWORD ERROR :", err);

      toast.error(
        err?.response?.data?.detail || "Failed to reset password"
      );
    } finally {
      setResettingPassword(false);
    }
  };

  const handleBackToLogin = () => {
    setShowForgot(false);
    setStep(1);
  };

  return (
    <div className="studentlogin-wrapper">

      <div className="studentlogin-card">

        <div className="studentlogin-left">

          <img
            src={studentlogin}
            className="studentlogin-image"
            alt="NHRC Student Login"
          />

          <div className="studentlogin-image-overlay"></div>

          <div className="studentlogin-overlay-content">

            <div className="studentlogin-logo-area">

              <div className="studentlogin-logo-icon">
                <FaGraduationCap />
              </div>

              <div>
                <h2>NHRC</h2>

                <span>
                  NATIONAL HUMAN RESOURCE CLUB
                </span>
              </div>

            </div>

            <div className="studentlogin-main-message">

              <h1>
                Learn.
                <br />
                Grow.
                <br />
                Lead.
              </h1>

              <div className="studentlogin-orange-line"></div>

              <h3>
                Be the Change!
              </h3>

              <p>
                Join NHRC and be part of a
                community that shapes your
                future.
              </p>

            </div>

            <div className="studentlogin-features">

              <div className="studentlogin-feature">

                <FaBookOpen />

                <strong>
                  Knowledge
                  <br />
                  & Learning
                </strong>

              </div>

              <div className="studentlogin-feature">

                <FaUsers />

                <strong>
                  Networking
                  <br />
                  & Opportunities
                </strong>

              </div>

              <div className="studentlogin-feature">

                <FaStar />

                <strong>
                  Personal
                  <br />
                  Growth
                </strong>

              </div>

            </div>

          </div>

        </div>

        <div className="studentlogin-right">

          <div className="studentlogin-body">

            <div className="studentlogin-top-icon">
              <FaGraduationCap />
            </div>

            <h3 className="studentlogin-title">

              {showForgot
                ? "Forgot Password"
                : "Student Login"}

            </h3>

            {!showForgot && (
              <p className="studentlogin-subtitle">
                Welcome back! Please sign in
                to continue.
              </p>
            )}

            <div className="studentlogin-title-line"></div>

            {!showForgot && (

              <form
                onSubmit={handleSubmit}
                className="studentlogin-form"
              >

                <div className="studentlogin-field">

                  <label>
                    Email Address
                  </label>

                  <div className="studentlogin-input-wrapper">

                    <FaEnvelope />

                    <input
                      type="email"
                      required
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) =>
                        setEmail(
                          e.target.value
                        )
                      }
                    />

                  </div>

                </div>

                <div className="studentlogin-field">

                  <label>
                    Password
                  </label>

                  <div className="studentlogin-input-wrapper">

                    <FaLock />

                    <input
                      type={
                        showPassword
                          ? "text"
                          : "password"
                      }
                      required
                      placeholder="Enter your password"
                      value={pass}
                      onChange={(e) =>
                        setPass(
                          e.target.value
                        )
                      }
                    />

                    <button
                      type="button"
                      className="studentlogin-eye"
                      onClick={() =>
                        setShowPassword(
                          !showPassword
                        )
                      }
                    >

                      {showPassword ? (
                        <FaEyeSlash />
                      ) : (
                        <FaEye />
                      )}

                    </button>

                  </div>

                </div>

                <div className="studentlogin-account-row">

                  <button
                    type="button"
                    className="studentlogin-forgot"
                    onClick={() => {
                      setShowForgot(true);
                      setStep(1);
                      setForgotEmail(email.trim());
                    }}
                  >
                    Forgot Password?
                  </button>

                </div>

                <div className="studentlogin-captcha-card">

                  <div className="studentlogin-captcha-title">

                    <FaShieldAlt />

                    <span>
                      Solve the captcha
                      to continue
                    </span>

                  </div>

                  <div className="studentlogin-captcha-row">

                    <div className="studentlogin-captcha-question">

                      {captchaLoading
                        ? "Loading..."
                        : captchaQuestion ||
                          "2 + 3 = ?"}

                    </div>

                    <input
                      type="text"
                      placeholder="Enter Answer"
                      value={captchaAnswer}
                      onChange={(e) => {
                        setCaptchaAnswer(
                          e.target.value
                        );

                        setCaptchaVerified(
                          false
                        );
                      }}
                    />

                    <button
                      type="button"
                      className={
                        captchaVerified
                          ? "captcha-verified"
                          : ""
                      }
                      onClick={
                        handleVerifyCaptcha
                      }
                      disabled={
                        captchaLoading
                      }
                    >

                      {captchaVerified
                        ? "Verified"
                        : "Verify"}

                    </button>

                  </div>

                  <div className="studentlogin-captcha-bottom">

                    {captchaVerified ? (
                      <span className="captcha-success">
                        ✓ Captcha verified
                        successfully!
                      </span>
                    ) : (
                      <span>
                        Please verify the
                        captcha
                      </span>
                    )}

                    <button
                      type="button"
                      className="captcha-refresh"
                      onClick={
                        loadCaptcha
                      }
                      title="Refresh captcha"
                    >
                      <FaSyncAlt />
                    </button>

                  </div>

                </div>

                <button
                  type="submit"
                  className="studentlogin-btn"
                  disabled={loading}
                >

                  <FaSignInAlt />

                  {loading
                    ? "Signing In..."
                    : "Login"}

                </button>

              </form>
            )}

            {showForgot && (

              <div className="studentlogin-forgot-container">

                {step === 1 && (
                  <>
                    <div className="studentlogin-field">

                      <label>
                        Email Address
                      </label>

                      <div className="studentlogin-input-wrapper">

                        <FaEnvelope />

                        <input
                          type="email"
                          placeholder="Enter your email"
                          value={forgotEmail}
                          onChange={(e) =>
                            setForgotEmail(
                              e.target.value
                            )
                          }
                        />

                      </div>

                    </div>

                    <button
                      className="studentlogin-btn"
                      onClick={verifyEmail}
                      disabled={sendingForgotOtp}
                    >
                      {sendingForgotOtp ? "Sending..." : "Send OTP"}
                    </button>
                  </>
                )}

                {step === 2 && (
                  <>
                    <div className="studentlogin-field">

                      <label>
                        Enter OTP
                      </label>

                      <div className="studentlogin-input-wrapper">

                        <FaShieldAlt />

                        <input
                          type="text"
                          placeholder="Enter OTP"
                          value={otp}
                          onChange={(e) =>
                            setOtp(
                              e.target.value
                            )
                          }
                        />

                      </div>

                    </div>

                    <div className="studentlogin-field">

                      <label>
                        New Password
                      </label>

                      <div className="studentlogin-input-wrapper">

                        <FaLock />

                        <input
                          type="password"
                          placeholder="New Password"
                          value={newPassword}
                          onChange={(e) =>
                            setNewPassword(
                              e.target.value
                            )
                          }
                        />

                      </div>

                    </div>

                    <div className="studentlogin-field">

                      <label>
                        Confirm Password
                      </label>

                      <div className="studentlogin-input-wrapper">

                        <FaLock />

                        <input
                          type="password"
                          placeholder="Confirm Password"
                          value={confirmPassword}
                          onChange={(e) =>
                            setConfirmPassword(
                              e.target.value
                            )
                          }
                        />

                      </div>

                    </div>

                    <button
                      className="studentlogin-btn"
                      onClick={
                        setPasswordHandler
                      }
                      disabled={resettingPassword}
                    >
                      {resettingPassword ? "Resetting..." : "Reset Password"}
                    </button>

                    <button
                      type="button"
                      className="captcha-refresh"
                      style={{ marginTop: "8px", width: "100%" }}
                      onClick={verifyEmail}
                      disabled={sendingForgotOtp}
                    >
                      Resend OTP
                    </button>
                  </>
                )}

                <button
                  className="studentlogin-back"
                  onClick={
                    handleBackToLogin
                  }
                >
                  ← Back to Login
                </button>

              </div>
            )}

            {!showForgot && (
              <div className="studentlogin-security">

                <FaShieldAlt />

                <span>
                  Secure Login&nbsp; | &nbsp;
                  Your data is protected with us
                </span>

              </div>
            )}

          </div>

        </div>

      </div>

      <Modal
        show={showRegister}
        onHide={() =>
          setShowRegister(false)
        }
        centered
        size="lg"
        backdrop="static"
        className="membership-modal"
      >

        <Modal.Header closeButton>

          <Modal.Title>
            Membership Form
          </Modal.Title>

        </Modal.Header>

        <Modal.Body>

          <Member />

        </Modal.Body>

      </Modal>

    </div>
  );
}

export default StudentLogin;